<template lang="pug">
    span.game-preview-setting
        div.game-preview-setting__name(:class="{'game-preview-setting__name_centered': $slots.image || inPuzzle}")
            slot(name="name")
        div.game-preview-setting__value(v-if="$slots.value")
            slot(name="value")
        div.game-preview-setting__image(v-if="$slots.image")
            slot(name="image")
</template>

<script>
    export default {
        props: {
            inPuzzle: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style lang="scss" scoped>
    $name-width: 250px;
    $name-mobile-width: 100px;
    .game-preview-setting {
        @include stack-space($space-small);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        @include media($md) {
            display: block;
            margin-bottom: 0;
        }
        &__name {
            float: left;
            overflow: hidden;
            clear: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            font-weight: 500;
            width: 100%;
            text-align: center;
            @include media($md) {
                text-align: left;
                width: $name-width;
            }
        }
        &_centered {
            width: 100%;
            text-align: center;
            margin-top: 20px;
        }
        &__image {
            margin: 30px 0 $space-x-small 0;
        }
        &__value {
            text-align: center;
            margin-left: 0;
            font-size: 16px;
            @include media($md) {
                text-align: left;
                margin-bottom: 8px;
                margin-left: $name-width;
            }
            &_with-image {
                margin-left: $name-width;
                margin-bottom: $space-x-small;
                font-size: 16px;
            }
        }
    }
</style>
